import React, { useEffect, useRef, useState } from 'react';

// Lottie animation URLs
export const ANIMATIONS = {
  correct: 'https://assets2.lottiefiles.com/packages/lf20_ya4ycrti.json',
  wrong: 'https://assets10.lottiefiles.com/packages/lf20_tl52xzvn.json',
  success: 'https://assets4.lottiefiles.com/packages/lf20_touohxv0.json',
  loading: 'https://assets9.lottiefiles.com/packages/lf20_x62chJ.json',
  confetti: 'https://assets5.lottiefiles.com/packages/lf20_u4yrau.json',
  stars: 'https://assets3.lottiefiles.com/packages/lf20_obhph3sh.json',
  thinking: 'https://assets9.lottiefiles.com/packages/lf20_ysrn2iwp.json',
  airplane: 'https://assets5.lottiefiles.com/packages/lf20_uu0x8lqv.json',
  badge: 'https://assets2.lottiefiles.com/packages/lf20_6tdmpy5e.json',
  checkmark: 'https://assets9.lottiefiles.com/packages/lf20_pqnfmone.json',
  error: 'https://assets3.lottiefiles.com/packages/lf20_qp1spzqv.json',
};

const LottieAnimation = ({ 
  animation = 'success', 
  width = 150, 
  height = 150, 
  loop = true,
  autoplay = true,
  className = '',
}) => {
  const playerRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const animUrl = typeof animation === 'string' && ANIMATIONS[animation] 
    ? ANIMATIONS[animation] 
    : animation;

  useEffect(() => {
    // Load lottie-player script if not already loaded
    if (!document.querySelector('script[src*="lottie-player"]')) {
      const script = document.createElement('script');
      script.src = 'https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js';
      script.async = true;
      script.onload = () => setIsLoaded(true);
      document.body.appendChild(script);
    } else {
      setIsLoaded(true);
    }
  }, []);

  if (!isLoaded) {
    return <div style={{ width, height }} className={className} />;
  }

  return (
    <lottie-player
      ref={playerRef}
      src={animUrl}
      background="transparent"
      speed="1"
      style={{ width: `${width}px`, height: `${height}px` }}
      loop={loop}
      autoplay={autoplay}
      className={className}
    />
  );
};

// Simple wrapper components for common use cases
export const CorrectAnimation = (props) => (
  <LottieAnimation animation="checkmark" loop={false} width={100} height={100} {...props} />
);

export const WrongAnimation = (props) => (
  <LottieAnimation animation="error" loop={false} width={100} height={100} {...props} />
);

export const SuccessAnimation = (props) => (
  <LottieAnimation animation="success" {...props} />
);

export const LoadingAnimation = (props) => (
  <LottieAnimation animation="loading" width={100} height={100} {...props} />
);

export const ConfettiAnimation = (props) => (
  <LottieAnimation animation="confetti" loop={false} width={300} height={300} {...props} />
);

export const AirplaneAnimation = (props) => (
  <LottieAnimation animation="airplane" {...props} />
);

export default LottieAnimation;
